import React from "react";
import "../styles/colors.css";
import "../styles/about.css";

import Contactform from "../components/Contactform";

import aboutusImage from "../assets/about/aboutus.webp";
import belief1 from "../assets/about/01.png";
import belief2 from "../assets/about/02.png";
import belief3 from "../assets/about/03.png";
import belief4 from "../assets/about/04.png";

import ceoImg from "../assets/about/ceo.webp";
import coFounderImg from "../assets/about/co-founder.webp";
import jitenImg from "../assets/about/jiten.webp";
import sanjayImg from "../assets/about/sanjay.webp";

import appr1 from "../assets/about/appr1.webp";
import appr2 from "../assets/about/appr2.webp";
import appr3 from "../assets/about/appr3.webp";

const About = () => {
  return (
    <main className="main-section">
      {/* --- About Us Section --- */}
      <section className="about-section">
        <img src={aboutusImage} alt="AboutUs" className="about-bg" />
        <div className="about-content">
          <h1 className="about-title">
            About
            <br />
            Us
          </h1>
          <div className="about-card">
            <h2>A Story of Vision, Persistence, and Personalized Finance</h2>
            <p>
              In 2021, what began as a personal initiative of managing our own
              investment portfolios quickly evolved into a deeper realization to
              leverage our expertise and serve clients across both local and
              global markets. As we ventured further, we encountered various
              industry challenges like diverse client needs, complex regulatory
              landscapes, and a reliable, scalable infrastructure. Yet, it was
              our commitment to innovation, and customer-centricity that laid
              the foundation for Serenityy.
            </p>
            <p>
              Today, Serenityy brings the best of both worlds, personalized
              boutique service and global expertise, powered by a dedicated team
              and forward-thinking technology. We specialize in personalized
              wealth management, marketing management and international estate
              planning.
            </p>
            <div className="about-socials">
              <a
                href="https://www.linkedin.com/company/serenityymarketingmanagement/posts/?feedView=all"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://www.instagram.com/serenityy.management/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>

              <a
                href="https://wa.me/971543065542"
                aria-label="Chat with us on WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* --- Our Aim Section --- */}
      <section className="our-aim-section">
        <h2 className="our-aim-title">
          Our <span className="aim-highlight">Aim</span>
        </h2>
        <p className="our-aim-text">
          To empower individuals and families to make informed financial
          decisions, achieve their life goals, and build enduring wealth— while
          fostering trust and long-lasting relationships.
        </p>
      </section>

      {/* --- Our Core Belief Section --- */}
      <section className="core-belief-section">
        <h2 className="core-belief-title">Our Core Belief</h2>
        <div className="core-belief-cards">
          <div className="belief-card">
            <img
              src={belief1}
              alt="Client Centricity"
              className="belief-icon"
            />
            <span>Client Centricity</span>
          </div>
          <div className="belief-card">
            <img
              src={belief2}
              alt="Personalized Solutions"
              className="belief-icon"
            />
            <span>Personalized Solutions</span>
          </div>
          <div className="belief-card">
            <img
              src={belief3}
              alt="Trust & Integrity"
              className="belief-icon"
            />
            <span>Trust &amp; Integrity</span>
          </div>
          <div className="belief-card">
            <img
              src={belief4}
              alt="Excellence Through Expertise"
              className="belief-icon"
            />
            <span>
              Excellence Through <br />
              Expertise
            </span>
          </div>
        </div>
      </section>

      {/* --- Who We Are Section --- */}
      <section className="who-we-are">
        <h2 className="who-title">
          Who <span className="who-highlight">we</span> are!
        </h2>
        <p className="who-body">
          At Serenityy, we believe a great team is the foundation of lasting
          success. We are united by a shared vision to make a meaningful impact
          on the lives we touch through personalized financial guidance.
        <br />
          Our team includes highly credentialed professionals and together we 
          bring experience in wealth management, financial planning, 
          international estate structuring, and client advisory services.
          <br />
          When you choose Serenityy, you’re backed by a dedicated advisory team,
          including a personal financial advisor and relationship manager, all
          committed to providing seamless financial support throughout your
          financial journey.
        </p>
      </section>

      {/* --- CEO Section --- */}
      <section className="ceo-section">
        <div className="ceo-left">
          <h2 className="ceo-name">
            Abhishek <span className="ceo-orange">Bhatia, CFA</span>
          </h2>
          <h4 className="ceo-title">Founder &amp; CEO</h4>
          <p className="ceo-intro">
            Abhishek Bhatia is a seasoned wealth management professional with
            14+ years of experience in the financial services industry. Known
            for his proactive approach and results-driven mindset, Abhishek
            brings a unique combination of strategic insight and personalized
            client care to every relationship. His ability to build trust,
            communicate effectively, and negotiate with confidence has earned
            him a strong reputation among clients and peers alike.
          </p>
          <p>
            With deep expertise in investment strategies, financial markets, and
            estate planning, he is passionate about designing need-based
            solutions that align with each client’s unique goals. Before
            founding Serenityy in 2021, he held key leadership roles at
            prominent institutions such as HSBC, FGB Bank, and ICICI, where he
            gained invaluable experience and industry insight.
          </p>
          <p>
            Under his leadership, Serenityy has grown into a trusted advisory
            firm known for delivering institutional-grade financial solutions
            with a personal touch. Abhishek’s thought leadership in global
            markets has also been recognized in publications such as Hindustan
            Chronicles, where he has shared his perspectives on international
            investment trends.
          </p>
        </div>
        <div className="ceo-right">
          <img src={ceoImg} alt="Abhishek Bhatia, CFA" className="ceo-photo" />
          <div className="ceo-photo-gradient"></div>
        </div>
      </section>

      {/* --- Team Section --- */}
      <section className="team-section">
        {/* --- Board Section --- */}
        <div className="board-section">
          <div className="board-row">
            <div className="board-info">
              <h2 className="board-title">
                Our Highly <span className="blue-text">Experienced Board</span>
              </h2>
              <p className="board-desc">
                Our board is composed of accomplished professionals with deep
                expertise across multiple industries. Each member brings a
                wealth of experience in areas such as insurance, financial
                planning, entrepreneurship, and strategic development. Their
                diverse backgrounds allow them to offer a broad and insightful
                perspective, helping us make informed decisions that align with
                our long-term vision.
              </p>
              <p className="board-desc">
                The board plays a critical role in guiding our firm’s direction,
                ensuring robust governance, and supporting our executive team
                with strategic insight. Their commitment to excellence helps us
                continuously improve, adapt, and deliver the highest standards
                of service to our clients.
              </p>
            </div>
            <div className="board-members-side">
              <div className="board-member">
                <img
                  src={jitenImg}
                  alt="Jiten Gajria"
                  className="board-member-photo"
                />
                <div className="board-member-name">Jiten Gajria</div>
              </div>
              <div className="board-member">
                <img
                  src={sanjayImg}
                  alt="Dr. Sanjay Tolani"
                  className="board-member-photo"
                />
                <div className="board-member-name">Dr. Sanjay Tolani</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Our Approach Section --- */}
      <section className="approach-section">
        <h2 className="approach-title">
          Our <span className="approach-orange">Approach</span>
        </h2>
        <div className="approach-subtext">
          Our approach is a direct reflection of our core beliefs, turning our
          commitment into practical solutions that drive impact.
        </div>
        <div className="approach-cards-row">
          <div className="approach-card">
            <div className="approach-card-desc">
              We help clients build a solid foundation with a plan that
              addresses both short- and long-term financial needs.
            </div>
            <div className="approach-card-img-wrap">
              <img
                src={appr1}
                alt="Financial Stability"
                className="approach-card-img"
              />
              <div className="approach-card-img-title">
                Financial
                <br />
                Stability
              </div>
            </div>
          </div>
          <div className="approach-card">
            <div className="approach-card-desc">
              We identify and evaluate high-potential investment opportunities
              balancing them with robust risk management.
            </div>
            <div className="approach-card-img-wrap">
              <img
                src={appr2}
                alt="Maximizing Returns"
                className="approach-card-img"
              />
              <div className="approach-card-img-title">
                Maximizing
                <br />
                Returns
              </div>
            </div>
          </div>
          <div className="approach-card">
            <div className="approach-card-desc">
              Through personalized legacy planning, we ensure wealth is
              protected and transferred efficiently to future generations.
            </div>
            <div className="approach-card-img-wrap">
              <img
                src={appr3}
                alt="Building Wealth"
                className="approach-card-img"
              />
              <div className="approach-card-img-title">
                Building
                <br />
                Wealth
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Contact Section --- */}
      <Contactform />
    </main>
  );
};

export default About;
